import {
  PRODUCT_ATTRIBUTE_API,
  PRODUCT_ATTRIBUTE_GROUP_API,
  PRODUCT_ATTRIBUTE_VALUE_API,
} from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import {
  RemovedProductAttributeGroupModel,
  ProductAttributeGroupModel,
  ProductAttributeModel,
  RemovedProductAttributeModel,
  ProductAttributeValueModel,
  RemovedProductAttributeValueModel,
} from "./product-attribute.models";

export const getProductAttributeGroupListApi = async (langCode?: string) => {
  const createResponse = await apiClient.getHttp<ProductAttributeGroupModel[]>(
    `${PRODUCT_ATTRIBUTE_GROUP_API}`,
    { params: { langCode } }
  );
  return createResponse;
};

export const removeProductAttributeGroupApi = async (
  removedModel: RemovedProductAttributeGroupModel
) => {
  const response = await apiClient.postHttp(
    `${PRODUCT_ATTRIBUTE_GROUP_API}/remove_list`,
    removedModel
  );
  return response;
};

export const getProductAttributeGroupByIdApi = async (
  id: number,
  langCode?: string
) => {
  return await apiClient.getHttp<ProductAttributeGroupModel>(
    `${PRODUCT_ATTRIBUTE_GROUP_API}/${id}`,
    { params: { langCode } }
  );
};

export const addProductAttributeGroupApi = async (
  model: ProductAttributeGroupModel,
  langCode?: string
) => {
  const response = await apiClient.postHttp<number>(
    `${PRODUCT_ATTRIBUTE_GROUP_API}`,
    model,
    { params: { langCode } }
  );
  return response;
};

export const updateProductAttributeGroupApi = async (
  model: ProductAttributeGroupModel,
  langCode?: string
) => {
  const response = await apiClient.putHttp<number>(
    `${PRODUCT_ATTRIBUTE_GROUP_API}`,
    model,
    { params: { langCode } }
  );
  return response;
};

export const getProductAttributeListApi = async (langCode?: string) => {
  const createResponse = await apiClient.getHttp<ProductAttributeModel[]>(
    `${PRODUCT_ATTRIBUTE_API}`,
    { params: { langCode } }
  );
  return createResponse;
};

export const removeProductAttributeApi = async (
  removedModel: RemovedProductAttributeModel
) => {
  const response = await apiClient.postHttp(
    `${PRODUCT_ATTRIBUTE_API}/remove_list`,
    removedModel
  );
  return response;
};

export const getProductAttributeByIdApi = async (
  id: number,
  langCode?: string
) => {
  return await apiClient.getHttp<ProductAttributeModel>(
    `${PRODUCT_ATTRIBUTE_API}/${id}`,
    { params: { langCode } }
  );
};

export const addProductAttributeApi = async (
  model: ProductAttributeModel,
  langCode?: string
) => {
  const response = await apiClient.postHttp<number>(
    `${PRODUCT_ATTRIBUTE_API}`,
    model,
    { params: { langCode } }
  );
  return response;
};

export const updateProductAttributeApi = async (
  model: ProductAttributeModel,
  langCode?: string
) => {
  const response = await apiClient.putHttp<number>(
    `${PRODUCT_ATTRIBUTE_API}`,
    model,
    { params: { langCode } }
  );
  return response;
};

export const getProductAttributeValueListApi = async (langCode?: string) => {
  const createResponse = await apiClient.getHttp<ProductAttributeValueModel[]>(
    `${PRODUCT_ATTRIBUTE_VALUE_API}`,
    { params: { langCode } }
  );
  return createResponse;
};

export const removeProductAttributeValueApi = async (
  removedModel: RemovedProductAttributeValueModel
) => {
  const response = await apiClient.postHttp(
    `${PRODUCT_ATTRIBUTE_VALUE_API}/remove_list`,
    removedModel
  );
  return response;
};

export const getProductAttributeValueByIdApi = async (
  id: number,
  langCode?: string
) => {
  return await apiClient.getHttp<ProductAttributeValueModel>(
    `${PRODUCT_ATTRIBUTE_VALUE_API}/${id}`,
    { params: { langCode } }
  );
};

export const addProductAttributeValueApi = async (
  model: ProductAttributeValueModel,
  langCode?: string
) => {
  const response = await apiClient.postHttp<number>(
    `${PRODUCT_ATTRIBUTE_VALUE_API}`,
    model,
    { params: { langCode } }
  );
  return response;
};

export const updateProductAttributeValueApi = async (
  model: ProductAttributeValueModel,
  langCode?: string
) => {
  const response = await apiClient.putHttp<number>(
    `${PRODUCT_ATTRIBUTE_VALUE_API}`,
    model,
    { params: { langCode } }
  );
  return response;
};
